function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../saito-overlay/saito-overlay');
var SaitoSyncTemplate = require('./saito-sync.template');
var POLL_INTERVAL_MS = 400;
var MIN_SYNCING_VISIBLE_MS = 500;
var SYNCING_FADE_MS = 220;
/** Matches `.saito-sync-progress-fill { transition: width 0.7s ease }` in saito-sync.css */
var PROGRESS_FILL_TRANSITION_MS = 700;
/** Pause at a full bar before the overlay fades out. */
var COMPLETE_HOLD_MS = 350;
var NEAR_TIP_BLOCK_THRESHOLD = 100n;
var ZERO_BLOCK_HASH = '0'.repeat(64);
var SaitoSync = /*#__PURE__*/function () {
  function SaitoSync(app, mod) {
    var _app$browser,
      _this$app,
      _this = this;
    _classCallCheck(this, SaitoSync);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.payload = null;
    this.displayed_current_block_id = null;
    this.local_current_block_id = null;
    this.active_target_block_id = null;
    this.sync_complete = false;
    this.sync_generation = 0;
    this.number_raf = null;
    this.beat_timer = null;
    this.poll_timer = null;
    this.poll_in_flight = false;
    this.fast_forward_in_progress = false;
    this.ui_mode = 'idle';
    this.initial_sync_completed = false;
    this.syncing_shown_at = null;
    this.ui_timer = null;
    this.fade_timer = null;
    this.pending_transition = null;
    if (app !== null && app !== void 0 && (_app$browser = app.browser) !== null && _app$browser !== void 0 && _app$browser.addStylesheet) {
      app.browser.addStylesheet('/saito/css-imports/saito-sync.css');
    }
    if ((_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.connection) !== null && _this$app !== void 0 && _this$app.on) {
      this.app.connection.on('on-blockchain-received', function (payload) {
        _this.payload = payload || {};
        void _this.onChunkReceived();
      });
    }
  }
  return _createClass(SaitoSync, [{
    key: "onChunkReceived",
    value: function () {
      var _onChunkReceived = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _document$body, _this$app2, _this$app2$returnActi, _this$payload, _this$payload3;
        var page_inhibits_overlay, active_mod, target, previous_target, new_target, _this$app3, _this$app3$getPeers, peers, _ref, _this$toBigInt, _this$app4, _this$payload2, peer_synced, _iterator, _step, peer, data, block_id, current, already_showing_syncing, local_id, payload, ancestor_id, ancestor_fields_present, no_shared_ancestor, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              page_inhibits_overlay = typeof document !== 'undefined' && ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.hasAttribute('data-inhibit-block-sync-overlay'));
              active_mod = (_this$app2 = this.app) === null || _this$app2 === void 0 || (_this$app2 = _this$app2.modules) === null || _this$app2 === void 0 || (_this$app2$returnActi = _this$app2.returnActiveModule) === null || _this$app2$returnActi === void 0 ? void 0 : _this$app2$returnActi.call(_this$app2);
              if (!(page_inhibits_overlay || (active_mod === null || active_mod === void 0 ? void 0 : active_mod.inhibit_block_sync_overlay) === true)) {
                _context.n = 1;
                break;
              }
              this.stopProgressPolling();
              this.cancelPendingUi();
              this.pending_transition = null;
              this.ui_mode = 'idle';
              this.syncing_shown_at = null;
              if (this.overlay.visible) {
                this.overlay.remove();
              }
              return _context.a(2);
            case 1:
              if (!this.initial_sync_completed) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              if (!(this.ui_mode === 'fast_forward')) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              target = this.toBigInt((_this$payload = this.payload) === null || _this$payload === void 0 ? void 0 : _this$payload.target_block_id);
              previous_target = this.active_target_block_id;
              new_target = target != null && (previous_target == null || target !== previous_target);
              if (this.sync_complete && new_target) {
                this.sync_complete = false;
                this.sync_generation += 1;
                this.cancelPendingUi();
                this.pending_transition = null;
                this.syncing_shown_at = null;
              }
              this.active_target_block_id = target;

              // Skip overlay when Rust already marks a peer synced and we have a block watermark.
              _context.p = 4;
              _context.n = 5;
              return (_this$app3 = this.app) === null || _this$app3 === void 0 || (_this$app3 = _this$app3.core) === null || _this$app3 === void 0 || (_this$app3 = _this$app3.network) === null || _this$app3 === void 0 || (_this$app3$getPeers = _this$app3.getPeers) === null || _this$app3$getPeers === void 0 ? void 0 : _this$app3$getPeers.call(_this$app3);
            case 5:
              peers = _context.v;
              if (!Array.isArray(peers)) {
                _context.n = 13;
                break;
              }
              peer_synced = false;
              _iterator = _createForOfIteratorHelper(peers);
              _context.p = 6;
              _iterator.s();
            case 7:
              if ((_step = _iterator.n()).done) {
                _context.n = 9;
                break;
              }
              peer = _step.value;
              data = typeof peer.get === 'function' ? peer.get() : null;
              if (!(data && data.is_synced)) {
                _context.n = 8;
                break;
              }
              peer_synced = true;
              return _context.a(3, 9);
            case 8:
              _context.n = 7;
              break;
            case 9:
              _context.n = 11;
              break;
            case 10:
              _context.p = 10;
              _t = _context.v;
              _iterator.e(_t);
            case 11:
              _context.p = 11;
              _iterator.f();
              return _context.f(11);
            case 12:
              block_id = (_ref = (_this$toBigInt = this.toBigInt((_this$app4 = this.app) === null || _this$app4 === void 0 || (_this$app4 = _this$app4.options) === null || _this$app4 === void 0 || (_this$app4 = _this$app4.blockchain) === null || _this$app4 === void 0 ? void 0 : _this$app4.last_block_id)) !== null && _this$toBigInt !== void 0 ? _this$toBigInt : this.toBigInt((_this$payload2 = this.payload) === null || _this$payload2 === void 0 ? void 0 : _this$payload2.current_block_id)) !== null && _ref !== void 0 ? _ref : 0n;
              if (!(peer_synced && block_id > 0n)) {
                _context.n = 13;
                break;
              }
              this.initial_sync_completed = true;
              this.sync_complete = true;
              this.stopProgressPolling();
              this.cancelPendingUi();
              this.pending_transition = null;
              this.ui_mode = 'idle';
              this.syncing_shown_at = null;
              if (this.overlay.visible) {
                this.overlay.remove();
              }
              return _context.a(2);
            case 13:
              _context.n = 15;
              break;
            case 14:
              _context.p = 14;
              _t2 = _context.v;
            case 15:
              current = this.getDisplayCurrentBlockId(); // Skip overlay when already within NEAR_TIP_BLOCK_THRESHOLD of the tip
              // (avoids a flash on browser refresh when nearly synced).
              if (!this.isNearTip(current, target)) {
                _context.n = 16;
                break;
              }
              this.initial_sync_completed = true;
              this.sync_complete = true;
              this.stopProgressPolling();
              this.cancelPendingUi();
              this.pending_transition = null;
              this.ui_mode = 'idle';
              this.syncing_shown_at = null;
              if (this.overlay.visible) {
                this.overlay.remove();
              }
              return _context.a(2);
            case 16:
              already_showing_syncing = this.ui_mode === 'syncing' && this.overlay.visible && !!document.getElementById('saito-sync') && !document.querySelector('#saito-sync.saito-sync-behind');
              this.render();
              this.applyCurrentProgress(current, already_showing_syncing);
              if (already_showing_syncing) {
                this.pulseVisual('saito-sync-beat');
              }
              this.pollLocalProgress(this.sync_generation);
              local_id = this.toBigInt((_this$payload3 = this.payload) === null || _this$payload3 === void 0 ? void 0 : _this$payload3.latest_known_block_id);
              payload = this.payload || {};
              ancestor_id = this.toBigInt(payload.shared_ancestor_block_id);
              ancestor_fields_present = payload.shared_ancestor_block_id != null || payload.shared_ancestor_block_hash != null;
              no_shared_ancestor = ancestor_fields_present && (ancestor_id == null || ancestor_id === 0n) && this.isZeroBlockHash(payload.shared_ancestor_block_hash);
              if (!(local_id != null && local_id > 0n && no_shared_ancestor)) {
                _context.n = 17;
                break;
              }
              this.scheduleFastForward();
              return _context.a(2);
            case 17:
              this.cancelPendingUi();
              this.startProgressPolling();
            case 18:
              return _context.a(2);
          }
        }, _callee, this, [[6, 10, 11, 12], [4, 14]]);
      }));
      function onChunkReceived() {
        return _onChunkReceived.apply(this, arguments);
      }
      return onChunkReceived;
    }()
    /**
     * Currently X: live tip, never below shared_ancestor_block_id when one exists.
     */
  }, {
    key: "getDisplayCurrentBlockId",
    value: function getDisplayCurrentBlockId(candidate) {
      var _ref2, _this$payload4, _this$payload5, _this$payload6;
      var tip = this.toBigInt((_ref2 = candidate !== null && candidate !== void 0 ? candidate : this.local_current_block_id) !== null && _ref2 !== void 0 ? _ref2 : (_this$payload4 = this.payload) === null || _this$payload4 === void 0 ? void 0 : _this$payload4.current_block_id);
      var ancestor_id = this.toBigInt((_this$payload5 = this.payload) === null || _this$payload5 === void 0 ? void 0 : _this$payload5.shared_ancestor_block_id);
      if (ancestor_id == null || ancestor_id <= 0n) {
        return tip;
      }
      if (this.isZeroBlockHash((_this$payload6 = this.payload) === null || _this$payload6 === void 0 ? void 0 : _this$payload6.shared_ancestor_block_hash)) {
        return tip;
      }
      if (tip == null || tip < ancestor_id) {
        return ancestor_id;
      }
      return tip;
    }
  }, {
    key: "isZeroBlockHash",
    value: function isZeroBlockHash(value) {
      if (value == null || value === '') {
        return true;
      }
      if (typeof value === 'string') {
        var hex = value.replace(/^0x/i, '').toLowerCase();
        return hex.length === 0 || hex === ZERO_BLOCK_HASH;
      }
      if (Array.isArray(value) || value instanceof Uint8Array) {
        return Array.from(value).every(function (_byte) {
          return Number(_byte) === 0;
        });
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
        _this$payload7;
      var existing = document.getElementById('saito-sync');
      var showing_syncing = this.overlay.visible && existing && !existing.classList.contains('saito-sync-behind');
      if (showing_syncing) {
        this.clearOverlayFade();
        this.ui_mode = 'syncing';
        if (this.syncing_shown_at == null) {
          this.syncing_shown_at = performance.now();
        }
        return;
      }
      this.cancelPendingUi();
      this.clearOverlayFade();
      this.ui_mode = 'syncing';
      this.syncing_shown_at = performance.now();
      this.overlay.show(SaitoSyncTemplate(this), function () {
        _this2.onOverlayClosed();
      });
      var skip = document.getElementById('saito-sync-skip');
      if (skip) {
        skip.onclick = function (event) {
          event.preventDefault();
          _this2.skipSyncWait();
        };
      }
      this.displayed_current_block_id = this.getDisplayCurrentBlockId();
      this.setTargetBlockText(this.toBigInt((_this$payload7 = this.payload) === null || _this$payload7 === void 0 ? void 0 : _this$payload7.target_block_id));
    }
  }, {
    key: "skipSyncWait",
    value: function skipSyncWait() {
      if (this.ui_mode !== 'syncing' || !this.overlay.visible) {
        return;
      }
      this.sync_complete = true;
      this.stopProgressPolling();
      this.cancelPendingUi();
      this.pending_transition = null;
      this.fadeOutSyncing();
    }
  }, {
    key: "onOverlayClosed",
    value: function onOverlayClosed() {
      this.initial_sync_completed = true;
      this.stopProgressPolling();
      this.cancelPendingUi();
      this.pending_transition = null;
      this.ui_mode = 'idle';
      this.syncing_shown_at = null;
      if (this.number_raf) {
        cancelAnimationFrame(this.number_raf);
        this.number_raf = null;
      }
      if (this.beat_timer) {
        clearTimeout(this.beat_timer);
        this.beat_timer = null;
      }
    }
  }, {
    key: "scheduleFastForward",
    value: function scheduleFastForward() {
      var _this$syncing_shown_a,
        _this3 = this;
      this.pending_transition = 'fast_forward';
      this.stopProgressPolling();
      this.cancelPendingUi();
      var shown_at = (_this$syncing_shown_a = this.syncing_shown_at) !== null && _this$syncing_shown_a !== void 0 ? _this$syncing_shown_a : performance.now();
      var wait = Math.max(0, MIN_SYNCING_VISIBLE_MS - (performance.now() - shown_at));
      this.ui_timer = setTimeout(function () {
        _this3.ui_timer = null;
        _this3.pending_transition = null;
        _this3.showTooFarBehind();
      }, wait);
    }
  }, {
    key: "scheduleDismissSyncing",
    value: function scheduleDismissSyncing() {
      var _this$payload8,
        _this$syncing_shown_a2,
        _this4 = this;
      if (this.ui_mode !== 'syncing' || this.initial_sync_completed || this.pending_transition === 'fast_forward') {
        return;
      }
      this.pending_transition = 'dismiss';
      this.stopProgressPolling();
      var fill = document.getElementById('saito-sync-progress-fill');
      var bar = document.getElementById('saito-sync-progress');
      var bar_remaining_ms = PROGRESS_FILL_TRANSITION_MS;
      if (fill && bar && bar.offsetWidth > 0) {
        var current_pct = Math.min(100, fill.offsetWidth / bar.offsetWidth * 100);
        bar_remaining_ms = Math.ceil((100 - Math.min(100, current_pct)) / 100 * PROGRESS_FILL_TRANSITION_MS);
      }
      var target = this.toBigInt((_this$payload8 = this.payload) === null || _this$payload8 === void 0 ? void 0 : _this$payload8.target_block_id);
      var current = this.getDisplayCurrentBlockId();
      this.setProgress(current, target);
      this.setCurrentBlockText(current);
      this.setTargetBlockText(target);
      var shown_at = (_this$syncing_shown_a2 = this.syncing_shown_at) !== null && _this$syncing_shown_a2 !== void 0 ? _this$syncing_shown_a2 : performance.now();
      var min_visible_remaining = Math.max(0, MIN_SYNCING_VISIBLE_MS - (performance.now() - shown_at));
      var wait = Math.max(min_visible_remaining, bar_remaining_ms) + COMPLETE_HOLD_MS;
      this.cancelPendingUi();
      this.ui_timer = setTimeout(function () {
        _this4.ui_timer = null;
        if (_this4.ui_mode !== 'syncing' || _this4.initial_sync_completed) {
          _this4.pending_transition = null;
          return;
        }
        _this4.pending_transition = null;
        _this4.fadeOutSyncing();
      }, wait);
    }
  }, {
    key: "fadeOutSyncing",
    value: function fadeOutSyncing() {
      var _this5 = this;
      if (this.ui_mode !== 'syncing' || !this.overlay.visible) {
        return;
      }
      var overlay_el = document.getElementById("saito-overlay".concat(this.overlay.ordinal));
      var backdrop_el = document.getElementById("saito-overlay-backdrop".concat(this.overlay.ordinal));
      var reduced = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var fade_ms = reduced ? 0 : SYNCING_FADE_MS;
      var fade_transition = fade_ms > 0 ? "opacity ".concat(fade_ms, "ms ease") : 'none';
      if (overlay_el) {
        overlay_el.style.transition = fade_transition;
        overlay_el.style.opacity = '0';
      }
      if (backdrop_el) {
        backdrop_el.style.transition = fade_transition;
        backdrop_el.style.opacity = '0';
      }
      this.fade_timer = setTimeout(function () {
        _this5.fade_timer = null;
        if (_this5.ui_mode === 'syncing') {
          _this5.overlay.close();
          _this5.ui_mode = 'idle';
          _this5.syncing_shown_at = null;
        }
      }, fade_ms);
    }
  }, {
    key: "cancelPendingUi",
    value: function cancelPendingUi() {
      if (this.ui_timer) {
        clearTimeout(this.ui_timer);
        this.ui_timer = null;
      }
      if (this.fade_timer) {
        clearTimeout(this.fade_timer);
        this.fade_timer = null;
      }
      if (this.number_raf) {
        cancelAnimationFrame(this.number_raf);
        this.number_raf = null;
      }
      if (this.beat_timer) {
        clearTimeout(this.beat_timer);
        this.beat_timer = null;
      }
    }
  }, {
    key: "clearOverlayFade",
    value: function clearOverlayFade() {
      var overlay_el = document.getElementById("saito-overlay".concat(this.overlay.ordinal));
      var backdrop_el = document.getElementById("saito-overlay-backdrop".concat(this.overlay.ordinal));
      [overlay_el, backdrop_el].forEach(function (el) {
        if (!el) {
          return;
        }
        el.style.removeProperty('opacity');
        el.style.removeProperty('transition');
      });
    }
  }, {
    key: "showTooFarBehind",
    value: function showTooFarBehind() {
      var _this6 = this;
      this.stopProgressPolling();
      this.cancelPendingUi();
      this.clearOverlayFade();
      this.ui_mode = 'fast_forward';
      this.overlay.show(SaitoSyncTemplate.tooFarBehind(this), function () {
        _this6.onOverlayClosed();
      });
      var button = document.getElementById('saito-sync-fast-forward');
      if (button) {
        button.onclick = function (event) {
          event.preventDefault();
          _this6.fastForwardWallet();
        };
      }
    }
  }, {
    key: "fastForwardWallet",
    value: function () {
      var _fastForwardWallet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this$app5, _this$app6;
        var button, error_el, wallet, blockchain, private_key, public_key, private_key_after_reset, public_key_after_reset, private_key_before_save, public_key_before_save, _t3;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!this.fast_forward_in_progress) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              button = document.getElementById('saito-sync-fast-forward');
              error_el = document.getElementById('saito-sync-error');
              wallet = (_this$app5 = this.app) === null || _this$app5 === void 0 ? void 0 : _this$app5.wallet;
              blockchain = (_this$app6 = this.app) === null || _this$app6 === void 0 ? void 0 : _this$app6.blockchain;
              this.fast_forward_in_progress = true;
              if (error_el) {
                error_el.textContent = '';
              }
              if (button) {
                button.disabled = true;
                button.textContent = 'FAST-FORWARDING...';
              }
              _context2.p = 2;
              this.stopProgressPolling();
              if (!(!(wallet !== null && wallet !== void 0 && wallet.getPrivateKey) || !(wallet !== null && wallet !== void 0 && wallet.getPublicKey))) {
                _context2.n = 3;
                break;
              }
              throw new Error('capture identity: wallet key APIs unavailable');
            case 3:
              _context2.n = 4;
              return wallet.getPrivateKey();
            case 4:
              private_key = _context2.v;
              _context2.n = 5;
              return wallet.getPublicKey();
            case 5:
              public_key = _context2.v;
              if (!(!private_key || !public_key)) {
                _context2.n = 6;
                break;
              }
              throw new Error('capture identity: missing wallet identity');
            case 6:
              if (!(typeof wallet.reset !== 'function')) {
                _context2.n = 7;
                break;
              }
              throw new Error('reset wallet: wallet.reset is unavailable');
            case 7:
              _context2.n = 8;
              return wallet.reset(true);
            case 8:
              _context2.n = 9;
              return wallet.getPrivateKey();
            case 9:
              private_key_after_reset = _context2.v;
              _context2.n = 10;
              return wallet.getPublicKey();
            case 10:
              public_key_after_reset = _context2.v;
              if (!(private_key_after_reset !== private_key || public_key_after_reset !== public_key)) {
                _context2.n = 11;
                break;
              }
              throw new Error('verify identity: keys changed during reset(true)');
            case 11:
              if (!(typeof (blockchain === null || blockchain === void 0 ? void 0 : blockchain.resetBlockchain) !== 'function')) {
                _context2.n = 12;
                break;
              }
              throw new Error('reset blockchain: blockchain.resetBlockchain is unavailable');
            case 12:
              _context2.n = 13;
              return blockchain.resetBlockchain();
            case 13:
              if (!(typeof wallet.fetchBalanceSnapshot !== 'function')) {
                _context2.n = 14;
                break;
              }
              throw new Error('recover balance: wallet.fetchBalanceSnapshot is unavailable');
            case 14:
              _context2.n = 15;
              return wallet.fetchBalanceSnapshot(public_key);
            case 15:
              _context2.n = 16;
              return wallet.getPrivateKey();
            case 16:
              private_key_before_save = _context2.v;
              _context2.n = 17;
              return wallet.getPublicKey();
            case 17:
              public_key_before_save = _context2.v;
              if (!(private_key_before_save !== private_key || public_key_before_save !== public_key)) {
                _context2.n = 18;
                break;
              }
              throw new Error('save wallet: keys changed before save');
            case 18:
              if (!(typeof wallet.saveWallet !== 'function')) {
                _context2.n = 19;
                break;
              }
              throw new Error('save wallet: wallet.saveWallet is unavailable');
            case 19:
              _context2.n = 20;
              return wallet.saveWallet();
            case 20:
              if (typeof reloadWindow === 'function') {
                reloadWindow(300);
              } else {
                window.location.reload();
              }
              _context2.n = 22;
              break;
            case 21:
              _context2.p = 21;
              _t3 = _context2.v;
              console.error('[SAITO SYNC] fast-forward failed:', _t3);
              if (error_el) {
                error_el.textContent = 'Fast-forward failed. Your wallet identity was not changed. ' + ((_t3 === null || _t3 === void 0 ? void 0 : _t3.message) || 'Please try again.');
              }
              if (button) {
                button.disabled = false;
                button.textContent = 'FAST-FORWARD WALLET';
              }
              this.fast_forward_in_progress = false;
            case 22:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 21]]);
      }));
      function fastForwardWallet() {
        return _fastForwardWallet.apply(this, arguments);
      }
      return fastForwardWallet;
    }()
  }, {
    key: "startProgressPolling",
    value: function startProgressPolling() {
      var _this7 = this;
      if (this.poll_timer || this.sync_complete) {
        return;
      }
      var generation = this.sync_generation;
      this.poll_timer = setInterval(function () {
        _this7.pollLocalProgress(generation);
      }, POLL_INTERVAL_MS);
    }
  }, {
    key: "stopProgressPolling",
    value: function stopProgressPolling() {
      if (this.poll_timer) {
        clearInterval(this.poll_timer);
        this.poll_timer = null;
      }
    }
  }, {
    key: "pollLocalProgress",
    value: function () {
      var _pollLocalProgress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(generation) {
        var _this$payload9;
        var target, latest, _this$app7, core_fn, _this$app8, wrapper_fn, display_current, previous, changed, _t4, _t5, _t6;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (!(generation !== this.sync_generation || this.sync_complete)) {
                _context3.n = 1;
                break;
              }
              this.stopProgressPolling();
              return _context3.a(2);
            case 1:
              if (!(this.pending_transition === 'fast_forward')) {
                _context3.n = 2;
                break;
              }
              this.stopProgressPolling();
              return _context3.a(2);
            case 2:
              if (!this.poll_in_flight) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2);
            case 3:
              target = this.toBigInt((_this$payload9 = this.payload) === null || _this$payload9 === void 0 ? void 0 : _this$payload9.target_block_id);
              if (this.ui_mode === 'syncing' && this.overlay.visible && target != null && target > 0n) {
                _context3.n = 4;
                break;
              }
              this.stopProgressPolling();
              return _context3.a(2);
            case 4:
              this.poll_in_flight = true;
              _context3.p = 5;
              latest = null;
              _context3.p = 6;
              core_fn = (_this$app7 = this.app) === null || _this$app7 === void 0 || (_this$app7 = _this$app7.core) === null || _this$app7 === void 0 || (_this$app7 = _this$app7.blockchain) === null || _this$app7 === void 0 ? void 0 : _this$app7.get_latest_block_id;
              if (!(typeof core_fn === 'function')) {
                _context3.n = 8;
                break;
              }
              _t4 = this;
              _context3.n = 7;
              return core_fn.call(this.app.core.blockchain);
            case 7:
              latest = _t4.toBigInt.call(_t4, _context3.v);
              _context3.n = 10;
              break;
            case 8:
              wrapper_fn = (_this$app8 = this.app) === null || _this$app8 === void 0 || (_this$app8 = _this$app8.blockchain) === null || _this$app8 === void 0 ? void 0 : _this$app8.getLatestBlockId;
              if (!(typeof wrapper_fn === 'function')) {
                _context3.n = 10;
                break;
              }
              _t5 = this;
              _context3.n = 9;
              return wrapper_fn.call(this.app.blockchain);
            case 9:
              latest = _t5.toBigInt.call(_t5, _context3.v);
            case 10:
              _context3.n = 12;
              break;
            case 11:
              _context3.p = 11;
              _t6 = _context3.v;
              latest = null;
            case 12:
              if (!(generation !== this.sync_generation || this.sync_complete)) {
                _context3.n = 13;
                break;
              }
              return _context3.a(2);
            case 13:
              if (!(this.pending_transition === 'fast_forward')) {
                _context3.n = 14;
                break;
              }
              return _context3.a(2);
            case 14:
              if (!(latest == null)) {
                _context3.n = 15;
                break;
              }
              return _context3.a(2);
            case 15:
              display_current = this.getDisplayCurrentBlockId(latest);
              this.local_current_block_id = display_current;
              previous = this.displayed_current_block_id;
              changed = previous == null || display_current !== previous;
              this.applyCurrentProgress(display_current, changed);
              if (changed && previous != null) {
                this.pulseVisual('saito-sync-tick');
              }
              if (!this.isNearTip(display_current, target)) {
                _context3.n = 17;
                break;
              }
              if (!(this.initial_sync_completed || this.ui_mode !== 'syncing')) {
                _context3.n = 16;
                break;
              }
              return _context3.a(2);
            case 16:
              this.sync_complete = true;
              this.stopProgressPolling();
              this.scheduleDismissSyncing();
            case 17:
              _context3.p = 17;
              this.poll_in_flight = false;
              return _context3.f(17);
            case 18:
              return _context3.a(2);
          }
        }, _callee3, this, [[6, 11], [5,, 17, 18]]);
      }));
      function pollLocalProgress(_x) {
        return _pollLocalProgress.apply(this, arguments);
      }
      return pollLocalProgress;
    }()
  }, {
    key: "applyCurrentProgress",
    value: function applyCurrentProgress(current, animate_number) {
      var _this$payload0;
      var target = this.toBigInt((_this$payload0 = this.payload) === null || _this$payload0 === void 0 ? void 0 : _this$payload0.target_block_id);
      var display_current = this.getDisplayCurrentBlockId(current);
      this.setTargetBlockText(target);
      if (animate_number) {
        this.animateCurrentBlock(this.displayed_current_block_id, display_current);
      } else {
        this.setCurrentBlockText(display_current);
      }
      this.displayed_current_block_id = display_current;
      this.setProgress(display_current, target);
    }
  }, {
    key: "pulseVisual",
    value: function pulseVisual(class_name) {
      var _this8 = this;
      var graphic = document.querySelector('#saito-sync .saito-sync-graphic');
      var progress = document.getElementById('saito-sync-progress');
      var current = document.getElementById('saito-sync-current-block');
      var beat_els = [graphic, progress, current].filter(Boolean);
      beat_els.forEach(function (el) {
        el.classList.remove('saito-sync-beat', 'saito-sync-tick');
        void el.offsetWidth;
        el.classList.add(class_name);
      });
      if (this.beat_timer) {
        clearTimeout(this.beat_timer);
      }
      this.beat_timer = setTimeout(function () {
        beat_els.forEach(function (el) {
          return el.classList.remove('saito-sync-beat', 'saito-sync-tick');
        });
        _this8.beat_timer = null;
      }, 720);
    }
  }, {
    key: "animateCurrentBlock",
    value: function animateCurrentBlock(from, to) {
      var _this9 = this;
      if (this.number_raf) {
        cancelAnimationFrame(this.number_raf);
        this.number_raf = null;
      }
      var to_safe = function to_safe(value) {
        var as_bigint = _this9.toBigInt(value);
        if (as_bigint == null) {
          return null;
        }
        if (as_bigint > BigInt(Number.MAX_SAFE_INTEGER) || as_bigint < 0n) {
          return null;
        }
        return Number(as_bigint);
      };
      var from_n = to_safe(from);
      var to_n = to_safe(to);
      if (from_n == null || to_n == null || from_n === to_n) {
        this.setCurrentBlockText(to);
        return;
      }
      var start = performance.now();
      var duration = 420;
      var _tick = function tick(now) {
        var t = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - t, 3);
        var value = from_n + (to_n - from_n) * eased;
        _this9.setCurrentBlockText(BigInt(Math.round(value)));
        if (t < 1) {
          _this9.number_raf = requestAnimationFrame(_tick);
        } else {
          _this9.number_raf = null;
          _this9.setCurrentBlockText(to);
        }
      };
      this.number_raf = requestAnimationFrame(_tick);
    }
  }, {
    key: "setCurrentBlockText",
    value: function setCurrentBlockText(value) {
      var el = document.getElementById('saito-sync-current-block');
      if (el) {
        el.textContent = this.formatBlockId(value);
      }
    }
  }, {
    key: "setTargetBlockText",
    value: function setTargetBlockText(value) {
      var el = document.getElementById('saito-sync-target-block');
      if (el) {
        el.textContent = this.formatBlockId(value);
      }
      var root = document.getElementById('saito-sync');
      var label = root ? root.querySelector('.saito-sync-progress-label') : null;
      if (label) {
        var formatted = this.formatBlockId(value);
        label.style.setProperty('--saito-sync-num-ch', String(formatted === '—' ? 4 : formatted.length));
      }
    }
  }, {
    key: "isNearTip",
    value: function isNearTip(current, target) {
      if (current == null || target == null || target <= 0n) {
        return false;
      }
      return current >= target - NEAR_TIP_BLOCK_THRESHOLD;
    }
  }, {
    key: "setProgress",
    value: function setProgress(current, target) {
      var fill = document.getElementById('saito-sync-progress-fill');
      var bar = document.getElementById('saito-sync-progress');
      var percent = 0;
      if (current != null && target != null && target > 0n) {
        percent = this.isNearTip(current, target) ? 100 : Number(current * 10000n / target) / 100;
      }
      if (fill) {
        fill.style.width = "".concat(percent, "%");
      }
      if (bar) {
        bar.setAttribute('aria-valuenow', String(Math.round(percent)));
      }
    }
  }, {
    key: "toBigInt",
    value: function toBigInt(value) {
      if (typeof value === 'bigint') {
        return value;
      }
      if (value == null || value === '') {
        return null;
      }
      try {
        return BigInt(value);
      } catch (err) {
        return null;
      }
    }
  }, {
    key: "formatBlockId",
    value: function formatBlockId(value) {
      var as_bigint = this.toBigInt(value);
      if (as_bigint == null) {
        return '—';
      }
      return as_bigint.toLocaleString('en-US');
    }
  }]);
}();
module.exports = SaitoSync;